import { XTextarea } from '@adornis/forms/x-textarea.js';
import { customElement } from 'lit/decorators.js';

/**
 * @customElement cr-textarea
 */
@customElement('cr-textarea')
export class ChromiumTextarea extends XTextarea {}
